import { Dimmer, Loader } from "semantic-ui-react";
import React, { useEffect, useState } from "react";
import './styles.css';

const PushInstruction = () => {
    const [loading, setLoading] = useState(true);

    const detectBrowser = () => {
        const userAgent = navigator.userAgent;

        const browserURLs = {
            YaBrowser: 'https://cms.asiaexpo.space/wp-content/uploads/2024/08/Инструкция-Push-Yandex.pdf',
            OPR: 'https://cms.asiaexpo.space/wp-content/uploads/2024/08/Инструкция-Push-Opera.pdf',
            Opera: 'https://cms.asiaexpo.space/wp-content/uploads/2024/08/Инструкция-Push-Opera.pdf',
            Edg: 'https://cms.asiaexpo.space/wp-content/uploads/2024/08/Инструкция-Push-Edge.pdf',
            Chrome: 'https://cms.asiaexpo.space/wp-content/uploads/2024/08/Инструкция-Push-Chrome.pdf',
            Firefox: 'https://cms.asiaexpo.space/wp-content/uploads/2024/08/Инструкция-Push-FireFox.pdf'
        };

        const matchedBrowser = Object.keys(browserURLs).find(key => userAgent.includes(key));

        return browserURLs[matchedBrowser] || browserURLs.Chrome;
    };

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <div className='instruction-pdf-view'>
            <iframe
                className='instruction-pdf-file'
                onLoad={() => setLoading(false)}
                src={detectBrowser()}
                title="Push Instruction"
            ></iframe>
            <Dimmer inverted active={loading}>
                <Loader />
            </Dimmer>
        </div>
    );
};

export default PushInstruction;